module.exports = __webpack_public_path__ + "c2c982dcf36e26021cd6fa68c5a921c6.svg";